module.exports = __webpack_public_path__ + "static/media/wedding06.9c18c094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/wedding06.jpg
// module id = 426
// module chunks = 0